// extracted by mini-css-extract-plugin
export var addressFields = "_qd-0";
export var animationContainer = "_qd-1";
export var footer = "_qd-2";
export var lineItems = "_qd-3";
export var modalContent = "_qd-4";
export var orderName = "_qd-5";
export var strong = "_qd-6";
export var warning = "_qd-7";